export const safetyLetterURL = `${process.env.SPARK_DOMAIN}/safety`;
export const configureSupportLinkURL = `${process.env.SPARK_SUPPORT_LINK}`;
export const trialNetworksTabLinkURL = `${process.env.SPARK_TRAIL_NETWORKS_TAB_LINK}`;
export const privacyPolicyLinkURL = `${process.env.SPARK_PRIVACY_POLICY_LINK}`;
export const versionLink = `${process.env.SPARK_VERSION_LINK}`;
export const privacyShieldLinkURL = `${process.env.SPARK_PRIVACY_SHIELD_LINK}`;
export const termsOfUseLinkURL = `${process.env.SPARK_TERMS_OF_USE_LINK}`;
export const ibURL = `${process.env.SPARK_DOMAIN}/ib`;

//@deprecated DO NOT USE
export const envName = `${process.env.ENV_NAME}`;

export const reportLinkURL = `${process.env.BASE_DOMAIN}${process.env.SPARK_REPORT_LINK}`;
export const bulkDownloadURL = `${process.env.SPARK_BULKDOWNLOAD_DOMAIN}/bulkDownload`;
export const ibBulkDownloadURL = `${process.env.SPARK_BULKDOWNLOAD_DOMAIN}/ib`;
export const gapPacketBulkDownloadURL = `${process.env.SPARK_BULKDOWNLOAD_DOMAIN}/gappacket`;
